<ion-header>
	<app-header (back)="goHome()" [customer]="customer"></app-header>
</ion-header>

<ion-content>
	<app-map-venue></app-map-venue>
</ion-content>
<!-- <ion-footer>
	<div class="footer_privacy">
		<p>2024 {{ 'cookie_consent.title.losteria' | translate }}</p>
		<div class="line_vertical" role="region" aria-label="Vertical line"></div>
		<p (click)="openPage('tos')">{{ 'menu_popover.terms' | translate }}</p>
		<div class="line_vertical" role="region" aria-label="Vertical line"></div>

		<p (click)="openPage('impressum')">{{ 'menu_popover.imprint' | translate }}</p>
		<div class="line_vertical"></div>

		<p (click)="openPage('privacy')">{{ 'menu_popover.privacy' | translate }}</p>
	</div>
</ion-footer> -->
